// Central drop configuration — Drop #2: 15:00 Polish time (CEST, UTC+2) on 14/10/2026 => 13:00 UTC
export const DROP_TIME = new Date("2026-10-14T13:00:00Z");

// Set to true to LOCK the whole site behind the countdown until DROP_TIME.
// Set to false to make the full site (home + shop) visible now, with the
// countdown available as its own /drop page.
export const GATE_ENABLED = true;

export const isDropLive = () => !GATE_ENABLED || Date.now() >= DROP_TIME.getTime();
